import React, { useState, useEffect } from "react";
import BorderedButton from "../../../Buttons/BorderedButton";
import PrimaryButton from "../../../Buttons/PrimaryButton";
import styles from "./Style.module.css";
import CustomRadio from "../../../CustomRadio/CustomRadio";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import { getBookingPreventChanges } from "../../../../Utils/BookingPreventChanges";

const CancelStep = ({ onClose, onConfirm, nextStep, status, buttonDisabled, error, bookingDeposit, bookingStatus, bookingType }) => {
	const { selectedBookingDeleteScope, setApiError, bookingDetails } = useGlobalContext();
	const { isBookingPaymentInProgress, isBookingCompleted } = getBookingPreventChanges(bookingDetails);
	const [selected, setSelected] = useState("cancelled");
	const [isConfirmDisabled, setIsConfirmDisabled] = useState(false);

	const outletBooking = bookingDetails?.panel.toLowerCase() === "outlet";
	const webBooking = bookingDetails?.panel.toLowerCase() === "customer";
	const hasDeposit = Number(bookingDeposit || 0) > 0;
	const canNotBeNoShow = isBookingPaymentInProgress || isBookingCompleted;
	const canBeDeleted = !hasDeposit && !webBooking;
	const isDeleteSelectionBlocked = selected === "deleted" && !canBeDeleted;
	useEffect(() => {
		const normalizedStatus = status?.toLowerCase();

		if (selectedBookingDeleteScope === "this_and_future") {
			setSelected("deleted");
			setIsConfirmDisabled(false);
		} else if (normalizedStatus === "no-show") {
			setSelected("no-show");
			setIsConfirmDisabled(true);
		} else if (normalizedStatus === "cancelled") {
			setSelected("cancelled");
			setIsConfirmDisabled(true);
		} else {
			setSelected("cancelled");
			setIsConfirmDisabled(false);
		}
	}, [status, selectedBookingDeleteScope]);

	useEffect(() => {
		if (selected === "deleted" && !canBeDeleted) {
			if (selectedBookingDeleteScope === "this_and_future") {
				setIsConfirmDisabled(true);
				return;
			}
			const normalizedStatus = status?.toLowerCase();
			const fallback = normalizedStatus === "no-show" ? "no-show" : "cancelled";
			setSelected(fallback);
			setIsConfirmDisabled(fallback === normalizedStatus);
		}
	}, [canBeDeleted, selected, status, selectedBookingDeleteScope]);


	const handleChange = (e) => {
		const value = e.target.value;
		if (value === "deleted" && !canBeDeleted) return;
		if (value === "no-show" && canNotBeNoShow) return;
		setSelected(value);
		if (value === "cancelled" || value === "no-show") {
			setApiError("");
		}
		const normalizedStatus = status?.toLowerCase();
		if (value === normalizedStatus) {
			setIsConfirmDisabled(true);
		} else {
			setIsConfirmDisabled(false);
		}
	};

	return (
		<div className={`${styles.cancelStep} popup`}>	
			<div className="header">
				<h2>Cancel / Delete Appointment</h2>
				<p>Please select the cancellation type.</p>
				{/* <p>Only web bookings with deposits can be marked as no-shows/normal cancellation.
				Outlet bookings with associated sales cannot be marked as no-shows/normal cancellation.
					Please refund the sale first if required.</p> */}
			</div>

			<div className="body">
				{selectedBookingDeleteScope === "this_and_future" ? "" : 
				(
					<div className={styles.groupInput}>
						<CustomRadio
							label="Normal Cancellation"
							name="customRadio"
							value="cancelled"
							checked={selected === "cancelled"}
							onChange={handleChange}
							disabled={selectedBookingDeleteScope === "this_and_future"}
						/>
						<CustomRadio
							label="No-Show"
							name="customRadio"
							value="no-show"
							checked={selected === "no-show"}
							onChange={handleChange}
							disabled={canNotBeNoShow || selectedBookingDeleteScope === "this_and_future"}
						/>
					</div>
					)	
				}

				<CustomRadio
					label="Just Delete It"
					subText="Bookings with a deposit or made through the web cannot be deleted. Please cancel instead to retain a proper record."
					name="customRadio"
					value="deleted"
					checked={selected === "deleted"}
					onChange={handleChange}
					disabled={!canBeDeleted}
				/>
			{error && <p className={`${styles.errorText} common-error-message`}>{error}</p>}
			</div>


			<div className="footer">
				<BorderedButton text="Cancel" onClick={onClose} />

				{
				hasDeposit && selected === "cancelled" && outletBooking ? (
					<PrimaryButton
						text="Next"
						onClick={() => {
							if (typeof nextStep === "function") {
								nextStep(selected);
							} else {
								onConfirm(selected);
							}
						}}
						disabled={isConfirmDisabled || buttonDisabled || isDeleteSelectionBlocked}
					/>

				) : (
					<PrimaryButton
						text={buttonDisabled ? "Processing..." : "Confirm"}
						onClick={() => onConfirm(selected)}
						disabled={isConfirmDisabled || buttonDisabled || isDeleteSelectionBlocked}
					/>
				)
				} 
				
			</div>
		</div>
	);
};

export default CancelStep;
